import classes from './CartItem.module.css';
import { cartActions } from '../../store/slices/CartSlice';
import {useDispatch} from 'react-redux'

const CartItem = (props) => {
  const { title, quantity, total, price,id } = props.item;
  const dispatch = useDispatch()
  const Deletar = ()=>{
    dispatch(cartActions.removeItemFromCart(id))
  }
  const Adicionar = ()=>{
    dispatch(cartActions.addItemsToCart({
      id,
      title,
      price
    }))
  }
  return (
    <li className={classes.item}>
      <header>
        <h3>{title}</h3>
        <div className={classes.price}>
          ${total.toFixed(2)}{' '}
          <span className={classes.itemprice}>(${price.toFixed(2)}/item)</span>
        </div>
      </header>
      <div className={classes.details}>
        <div className={classes.quantity}>
          x <span>{quantity}</span>
        </div>
        <div className={classes.actions}>
          <button onClick={Deletar}>-</button>
          <button onClick={Adicionar}>+</button>
        </div>
      </div>
    </li>
  );
};

export default CartItem;
